import picklistData from '@/services/picklist-data';

export default {
  namespaced: true,
  state() {
    return {
      billingStatuses: [],
    };
  },
  mutations: {
    setBillingStatuses(state, payload) {
      state.billingStatuses = payload;
    },
  },
  getters: {},
  actions: {
    async fetchBillStatuses({ commit }) {
      const rest = await picklistData.methods.getBillStatusData();
      console.log('response from service is');
      console.log(rest);
      commit('setBillingStatuses', rest);
    },

  },
};
